import * as React from "react";
import { useLocalStorage } from "@grandvisionhq/lib-utils-w3c";
import { getDisplayName } from "@grandvisionhq/utils";
function withScridId() {
  return (PageComponent) => {
    const displayName = getDisplayName(PageComponent);
    const WithScrid = (pageProps) => {
      const [scridId, setScridId] = useLocalStorage("SCRID_KEY");
      const { scrid } = pageProps;
      React.useEffect(() => {
        if (scrid && scridId !== scrid) {
          setScridId(scrid);
        }
      }, [scrid]);
      return /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps });
    };
    WithScrid.getInitialProps = async (ctx) => {
      const { scrid } = ctx.query || {};
      if (typeof PageComponent.getInitialProps === "function") {
        const pageProps = await PageComponent.getInitialProps(ctx);
        return {
          ...pageProps,
          scrid
        };
      }
      return { scrid };
    };
    WithScrid.displayName = `WithScridId(${displayName})`;
    return WithScrid;
  };
}
export {
  withScridId
};
//# sourceMappingURL=with-scrid.js.map
